import React, { FC } from "react";

interface IconProps {
  color?: string;
  filled?: boolean;
}

const RoundedCheck: FC<IconProps> = ({ color = "#62CBA5", filled = true }) => (
  <svg
    viewBox="0 0 16 16"
    fill={filled ? color : "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="6.25" stroke={color} strokeWidth="1.5" />
    <path
      d="m6 7.582 1.583 1.582L10.747 6"
      stroke={filled ? "#fff" : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RoundedCheck;
